import { Box } from "@mui/material";
import { AppCircularProgress } from "./Components/Progress/AppCircularProgress";
import { useExternalSso } from "./Hooks/Home";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import qs from "qs";
import { getSsoParam } from "JS/Helpers/SsoHelpers";

export const SSO = () => {
    const location = useLocation();
    const { fetch } = useExternalSso();
    useEffect(() => {
        const parsedQueryString = qs.parse(location.search, {
            ignoreQueryPrefix: true,
        });

        const accessToken = getSsoParam(parsedQueryString.accessToken);
        const memberId = getSsoParam(parsedQueryString.memberId);

        if (accessToken === null || memberId === null) return;
        fetch(accessToken, memberId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.search]);
    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100dvh"
        >
            <AppCircularProgress />
        </Box>
    );
};
